import { STORAGE_KEY_ON_BOARDING_DELETE_HIDE } from '../../constants/config';
import { getLocalStorage } from './getLocalStorage';
export var getOnBoardingDeleteVisible = function getOnBoardingDeleteVisible() {
  var storage = getLocalStorage();
  return storage ? !Boolean(storage.getItem(STORAGE_KEY_ON_BOARDING_DELETE_HIDE)) : false;
};